/**
 * Theme manifest: "Big Tech".
 *
 * A restrained, hairline-based design language modelled on how large research
 * organisations actually present work — type carries the hierarchy, borders and
 * whitespace carry the structure, and exactly one accent hue carries
 * interaction. See ./tokens.css for the values and ./skin.css for how the
 * semantic classes in src/ui are dressed.
 *
 * To build a different look, copy this directory, change `id`, rewrite the two
 * stylesheets, and register it in ../index.js. No component code changes.
 *
 * 主题清单：「大厂风」。
 *
 * 一套克制的、以发丝线为基础的设计语言，参照大型研究机构真实的呈现方式——
 * 层级由字体承担，结构由边框和留白承担，交互由唯一一个强调色承担。
 * 取值见 ./tokens.css，src/ui 语义类的皮肤见 ./skin.css。
 *
 * 要做另一套外观：复制本目录、改 id、重写这两个样式表、在 ../index.js 里注册。
 * 不需要改动任何组件代码。
 */

export default {
  id: 'bigtech',
  labelZh: '大厂风',
  labelEn: 'Big Tech',
  descriptionZh: '发丝线分隔、单一强调色、字体主导层级。信息密度高，装饰趋近于零。',
  descriptionEn: 'Hairline separators, a single accent, type-led hierarchy. Dense, near-zero ornament.',

  /**
   * Stylesheets are imported statically in src/main.jsx and scope themselves to
   * `[data-theme-pack="bigtech"]`, so switching themes is one attribute write
   * with no async load and no flash of unstyled content.
   *
   * 样式表在 src/main.jsx 静态引入，并自我限定在 [data-theme-pack="bigtech"] 之下，
   * 因此换主题只是写一个属性——无异步加载、无样式闪烁。
   */
  stylesheets: ['./tokens.css', './skin.css'],

  /** Colour modes this theme genuinely supports. 本主题真正支持的明暗模式。 */
  supports: { light: true, dark: true },
}
